import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

/**
 * Icon for BoxStaffFinancial, it's a calculator with expense report
 * @param props
 * @returns
 */
export const BoxStaffFinancialIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.5276 11.2461H37.919C37.919 11.2461 42.2068 15.2704 41.8777 18.4707C41.5991 21.1794 38.6356 21.5837 37.919 24.2107C37.3495 26.2988 37.919 29.7529 37.919 29.7529H27.5276C27.5276 29.7529 26.958 26.2988 27.5276 24.2107C28.2441 21.5837 31.2076 21.1794 31.4862 18.4707C31.8153 15.2704 27.5276 11.2461 27.5276 11.2461Z"
      fill="#E6E6E6"
    />
    <mask
      id="mask0_12328_76547"
      maskUnits="userSpaceOnUse"
      x="27"
      y="11"
      width="17"
      height="24"
      style={{ maskType: "alpha" }}
    >
      <path
        d="M27.9197 12.597L38.2517 11.4867C38.2517 11.4867 43.0153 15.6858 43.0861 19.4245C43.146 22.589 40.2497 23.3735 39.8639 26.4903C39.5573 28.9676 40.5532 32.9041 40.5532 32.9041L30.2212 34.0143C30.2212 34.0143 29.2253 30.0779 29.5319 27.6006C29.9177 24.4838 32.814 23.6993 32.7541 20.5348C32.6833 16.7961 27.9197 12.597 27.9197 12.597Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_12328_76547)">
      <path
        d="M27.9197 12.597L38.2517 11.4867C38.2517 11.4867 43.0153 15.6858 43.0861 19.4245C43.146 22.589 40.2497 23.3735 39.8639 26.4903C39.5573 28.9676 40.5532 32.9041 40.5532 32.9041L30.2212 34.0143C30.2212 34.0143 29.2253 30.0779 29.5319 27.6006C29.9177 24.4838 32.814 23.6993 32.7541 20.5348C32.6833 16.7961 27.9197 12.597 27.9197 12.597Z"
        fill="#F2F2F2"
      />
      <ellipse cx="33.72" cy="32.3711" rx="6.44464" ry="7.20309" fill="white" />
      <ellipse cx="33.5382" cy="14.441" rx="7.15933" ry="4.54745" fill="white" />
    </g>
    <path
      d="M34.1467 10.5601L35.2055 12.6939C35.3027 12.89 35.3101 13.1186 35.2256 13.3205V13.3205C35.0523 13.7347 34.5577 13.9068 34.1647 13.6895L33.9948 13.5956C33.8262 13.5024 33.6908 13.3591 33.6073 13.1856L32.7433 11.3897C32.5336 10.9539 32.6659 10.4305 33.0574 10.1466L33.2126 10.034C33.6875 9.68969 34.3554 9.82611 34.6572 10.3291L36.4504 13.3178C36.6184 13.5978 36.6391 13.9422 36.5059 14.2403L36.1674 14.9977C35.9981 15.3764 35.6126 15.6113 35.1984 15.5881L34.6111 15.5551C34.2611 15.5355 33.9468 15.334 33.783 15.024L31.8439 11.3553"
      stroke="#959693"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <mask
      id="mask1_12328_76547"
      maskUnits="userSpaceOnUse"
      x="6"
      y="15"
      width="25"
      height="26"
      style={{ maskType: "alpha" }}
    >
      <rect x="6.49316" y="15.623" width="24" height="25.0894" rx="2" fill="#6450F7" />
    </mask>
    <g mask="url(#mask1_12328_76547)">
      <rect x="6.49316" y="15.623" width="24" height="25.0894" rx="2" fill="url(#paint0_radial_12328_76547)" />
    </g>
    <rect x="8.45312" y="17.9707" width="19.9883" height="4.99933" rx="1" fill="url(#paint1_linear_12328_76547)" />
    <rect x="8.45312" y="34.7041" width="4" height="4" rx="1" fill="white" />
    <rect x="8.45312" y="29.8906" width="4" height="4" rx="1" fill="white" />
    <rect x="8.45312" y="25.0771" width="4" height="4" rx="1" fill="white" />
    <rect x="13.8135" y="34.7041" width="4" height="4" rx="1" fill="white" />
    <rect x="13.8135" y="29.8906" width="4" height="4" rx="1" fill="white" />
    <rect x="13.8135" y="25.0771" width="4" height="4" rx="1" fill="white" />
    <rect x="19.1729" y="34.7041" width="4" height="4" rx="1" fill="white" />
    <rect x="19.1729" y="29.8906" width="4" height="4" rx="1" fill="white" />
    <rect x="19.1729" y="25.0771" width="4" height="4" rx="1" fill="white" />
    <rect x="24.5332" y="29.8906" width="3.96568" height="8.83828" rx="1" fill="white" />
    <rect x="24.5332" y="25.0771" width="3.96568" height="3.62565" rx="1" fill="white" />
    <defs>
      <radialGradient
        id="paint0_radial_12328_76547"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.312 23.5585) rotate(32.8167) scale(24.2983 30.6199)"
      >
        <stop offset="0.496576" stopColor="#6450F7" />
        <stop offset="0.5" stopColor="#3B3184" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_12328_76547"
        x1="20.9207"
        y1="16.8506"
        x2="23.381"
        y2="22.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5" stopColor="#454643" />
        <stop offset="0.5" stopColor="#282828" />
      </linearGradient>
    </defs>
  </svg>
)
